import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button
} from "@chakra-ui/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

function ConfirmationDialog({ isOpen, onClose, onConfirm, headerText, confirmationText }) {
  const cancelRef = useRef();
  const { t } = useTranslation("translation", {
    keyPrefix: "buttons"
  });

  return (<AlertDialog
    isOpen={isOpen}
    leastDestructiveRef={cancelRef}
    onClose={onClose}
  >
    <AlertDialogOverlay>
      <AlertDialogContent>
        <AlertDialogHeader fontSize="lg" fontWeight="bold">
          {headerText}
        </AlertDialogHeader>

        <AlertDialogBody>
          {confirmationText}
        </AlertDialogBody>

        <AlertDialogFooter>
          <Button colorScheme="red" ref={cancelRef} onClick={onClose}>
            {t("no")}
          </Button>
          <Button colorScheme="green" onClick={onConfirm} ml={3}>
            {t("yes")}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialogOverlay>
  </AlertDialog>);
}

export default ConfirmationDialog;